import { useSelector } from 'react-redux';

import { Button, SvgIcon } from '@portal/common/components';

import config from '../../config';
import _ from '../../locale';
import { getCombinedSelectedFiltersCount } from '../../store/data-explorer/selectors';
import { useDataExplorerLayout } from '../DataExplorer/context';

type Props = {
    isLoading: boolean;
    disabled: boolean;
    onClick: () => void;
    className?: string;
};

const RunQueryButton = ({ isLoading, disabled, onClick, className }: Props) => {
    const { isCompact } = useDataExplorerLayout();

    const filtersCount = useSelector(getCombinedSelectedFiltersCount);

    const canQuery = filtersCount && filtersCount < config.combinedFiltersCountLimit;
    const size = isCompact ? 'xs' : 'md';

    return (
        <Button
            data-testid="apply-filters"
            color="primary"
            loading={isLoading}
            disabled={disabled || !canQuery}
            onClick={onClick}
            size={size}
            className={className}
            tooltip={canQuery ? undefined : _('run_query_button_disabled_tooltip')}
            tooltipPlacement="bottom"
        >
            <SvgIcon
                style={{ marginRight: 10 }}
                src="/icons/ic-search-main.svg"
                color={(theme) => theme.color.white}
            />
            {_.get('select_data_apply_filters')}
        </Button>
    );
};

export default RunQueryButton;
